import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  emailView: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gmailBar: {
    height: 56,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    gap: theme.spacing(1.5),
    flexShrink: 0,
  },
  gmailHamburger: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    cursor: 'default',
  },
  gmailHamburgerLine: {
    width: 18,
    height: 2,
    borderRadius: 1,
    backgroundColor: theme.palette.text.secondary,
  },
  gmailLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  gmailLogo: {
    color: theme.palette.text.secondary,
    fontSize: 20,
    fontWeight: 400,
    letterSpacing: '-0.5px',
  },
  gmailSearch: {
    flex: 1,
    backgroundColor: theme.palette.background.default,
    borderRadius: 24,
    height: 36,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
  },
  gmailSearchText: {
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
  gmailContent: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  gmailMain: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
  },
  emailActionBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  emailActionBarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  emailActionBarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  emailActionIcon: {
    color: theme.palette.text.secondary,
    cursor: 'default',
    flexShrink: 0,
  },
  emailPagination: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  emailThread: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2, 3),
  },
  emailHeader: {
    marginBottom: theme.spacing(2),
  },
  emailSubjectRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  emailSubject: {
    fontSize: 20,
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  emailSubjectTags: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flex: 1,
  },
  emailTag: {
    fontSize: 11,
    padding: '2px 8px',
    borderRadius: 4,
    backgroundColor: theme.palette.gmail.lightBlue,
    color: theme.palette.gmail.blue,
    cursor: 'default',
  },
  emailHeaderIcons: {
    display: 'flex',
    gap: theme.spacing(1),
    marginLeft: 'auto',
  },
  emailSenderRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  emailAvatar: {
    width: 36,
    height: 36,
    fontSize: 14,
    backgroundColor: theme.palette.gmail.blue,
    flexShrink: 0,
  },
  emailSenderInfo: {
    flex: 1,
  },
  emailSenderNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    flexWrap: 'wrap',
  },
  emailSenderName: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  emailSenderAddress: {
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  emailSenderUnsub: {
    fontSize: 12,
    color: theme.palette.gmail.blue,
    cursor: 'default',
  },
  emailSenderTo: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  emailSenderActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  emailTime: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  emailBody: {
    position: 'relative',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
  },
  emailBodyIframe: {
    width: '100%',
    border: 'none',
    display: 'block',
  },
  emailBodyOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
  },
  emailBodyPlaceholder: {
    padding: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emailReplyBar: {
    display: 'flex',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(1),
  },
  emailReplyBtn: {
    padding: theme.spacing(0.5, 2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    cursor: 'default',
  },
  emailReplyBtnText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
